import React, { FC } from 'react';

import { t } from 'state/intl/translations';
import { getDesignToken, spacing } from 'styles/constants';

import { MethodType, TextContainer } from './styled';

interface IVenmoMethod {
  isDisabled?: boolean;
  isRedesign?: boolean;
}

const VenmoMethod: FC<IVenmoMethod> = ({ isDisabled, isRedesign }) => {
  const textProps = isRedesign
    ? { variant: 'headerTwo', fontSize: 'lg', marginTop: spacing.$2 }
    : null;

  return (
    <TextContainer>
      <MethodType
        color={isDisabled ? getDesignToken('text-disabled') : getDesignToken('text-default')}
        {...textProps}
      >
        {t('venmo')}
      </MethodType>
    </TextContainer>
  );
};

export default VenmoMethod;
